(() => {
  const CTA = '[class*="button"],[class*="btn"],[class*="__book"],[class*="__cta"]';
  let dialog = null;
  let trigger = null;

  const isBookingTrigger = (el) => {
    if (!dialog || dialog.contains(el) || el.closest('[data-abm-book-skip]')) return false;
    if (el.matches('[data-abm-book]')) return true;
    const href = el.getAttribute('href') || '';
    if (/#book(-consultation)?$/.test(href)) return true;
    return dialog.dataset.interceptPhone === 'true' && href.startsWith('tel:') && el.matches(CTA);
  };

  const open = (from) => {
    trigger = from;
    document.documentElement.classList.add('abm-booking-lock');
    dialog.classList.remove('is-closing');
    dialog.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-visible')));
    dialog.querySelector('.abm-bk__call, .abm-bk__close')?.focus({ preventScroll: true });
  };

  const close = () => {
    if (!dialog.open || dialog.classList.contains('is-closing')) return;
    dialog.classList.add('is-closing');
    dialog.classList.remove('is-visible');
    const done = () => {
      dialog.close();
      dialog.classList.remove('is-closing');
      document.documentElement.classList.remove('abm-booking-lock');
      trigger?.focus?.({ preventScroll: true });
    };
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ? done() : setTimeout(done, 380);
  };

  const bind = () => {
    dialog = document.querySelector('[data-abm-booking]');
    if (!dialog || dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-abm-booking-close]')) close();
    });
  };

  document.addEventListener('click', (event) => {
    const el = event.target.closest('a, button');
    if (!el || event.metaKey || event.ctrlKey || event.shiftKey) return;
    if (!isBookingTrigger(el)) return;
    event.preventDefault();
    open(el);
  }, true);

  bind();
  document.addEventListener('shopify:section:load', bind);
  document.addEventListener('shopify:block:select', (event) => {
    bind();
    if (dialog && dialog.contains(event.target) && !dialog.open) open(null);
  });
  document.addEventListener('shopify:section:select', (event) => {
    bind();
    if (dialog && event.target.contains(dialog) && !dialog.open) open(null);
  });
  document.addEventListener('shopify:section:deselect', (event) => {
    if (dialog && event.target.contains(dialog)) close();
  });
})();
